import { render, staticRenderFns } from "./QuestionnaireReportPrintPage.vue?vue&type=template&id=635ac030&scoped=true&"
import script from "./QuestionnaireReportPrintPage.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireReportPrintPage.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireReportPrintPage.vue?vue&type=style&index=0&id=635ac030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ac030",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow,VSpacer})
